import React from "react";
import {Table} from "react-bootstrap";
import {IManualModel} from "../../types/manualFinder";
import ManualRow from "./ManualRow";
import {useTranslation} from "react-i18next";

interface MatchingManualsTableProps {
    manuals: IManualModel[];
    setIsLoading: (loading: boolean) => void;
}

const MatchingManualsTable: React.FC<MatchingManualsTableProps> = ({manuals, setIsLoading}) => {
    const {t} = useTranslation();

    return (
        <Table striped bordered hover>
            <thead>
            <tr>
                <th>ID</th>
                <th>{t("Manual.ItemMpText")}</th>
                <th>{t("Manual.ManualName")}</th>
                <th>{t("SpecialTool.MatchedTools")}</th>
                <th>{t("SpecialTool.AdditionalTools")}</th>
                <th>{t("SpecialTool.MissingTools")}</th>
            </tr>
            </thead>
            <tbody>
            {manuals.map((manual, index) => (
                <ManualRow key={index} manual={manual} setIsLoading={setIsLoading}/>
            ))}
            </tbody>
        </Table>
    );
};

export default MatchingManualsTable;
